import { z } from 'zod';
import { UserRole } from '../enums.js';
export const loginRequest = z.object({
    email: z.string().email(),
    password: z.string().min(8),
    /**
     * Zweiter Faktor — nur nötig, wenn 2FA für den Account aktiv ist:
     * 6-stelliger TOTP-Code oder ein Recovery-Code (XXXX-XXXX). Fehlt er bei
     * aktivem 2FA, antwortet das API mit 401 `two-factor-required`.
     */
    otp: z.string().min(6).max(32).optional(),
});
export const authUser = z.object({
    id: z.number().int().positive(),
    email: z.string().email(),
    fullName: z.string(),
    role: UserRole,
    showLegalHints: z.boolean().default(true),
});
export const loginResponse = z.object({
    accessToken: z.string(),
    user: authUser,
});
export const refreshResponse = z.object({
    accessToken: z.string(),
});
export const changePasswordRequest = z.object({
    currentPassword: z.string(),
    newPassword: z.string().min(10),
});
// --- Zwei-Faktor-Authentifizierung (TOTP, RFC 6238) ---
export const twoFactorStatus = z.object({
    enabled: z.boolean(),
    /** Anzahl noch nicht verbrauchter Recovery-Codes (0 wenn 2FA aus). */
    recoveryCodesRemaining: z.number().int().nonnegative(),
});
export const twoFactorSetupResponse = z.object({
    /** Base32-Secret für die manuelle Eingabe in die Authenticator-App. */
    secret: z.string(),
    /** otpauth://-URL (Inhalt des QR-Codes). */
    otpauthUrl: z.string(),
    /** Fertiger QR-Code als data:image/png-URL — direkt als <img src> nutzbar. */
    qrDataUrl: z.string(),
});
export const twoFactorVerifyRequest = z.object({
    /** 6-stelliger TOTP-Code aus der Authenticator-App. */
    otp: z.string().min(6).max(8),
});
export const twoFactorVerifyResponse = z.object({
    /** Einmalig angezeigte Klartext-Recovery-Codes — der Server speichert nur Hashes. */
    recoveryCodes: z.array(z.string()).length(10),
});
export const twoFactorDisableRequest = z.object({
    password: z.string().min(8),
    /** TOTP- oder Recovery-Code — Deaktivieren braucht beide Faktoren. */
    otp: z.string().min(6).max(32),
});
